import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { StoresService } from '../../../stores/stores.service';
import { WindowRefService } from "../../../window.service";
import {Store} from "@ngrx/store";
import {HideLoader, ShowLoader} from "../../../loader/+state/loader.actions";

@Component({
  selector: 'app-qr-code-image',
  templateUrl: './qr-code-image.component.html',
  styleUrls: ['./qr-code-image.component.scss']
})
export class QrCodeImageComponent implements OnInit, OnDestroy {
  @Input() storeId: number;
  @Input() data: string;
  qrImageSrc: string | null = null;
  window: Window;

  private destroyed$ = new Subject<void>();

  constructor(private storesService: StoresService,
              private windowRefService: WindowRefService,
              private store: Store<any>,) {
    this.window = this.windowRefService.nativeWindow;
  }

  ngOnInit(): void {
    if (this.storeId && this.data) {
      this.storesService.downloadQRImage(this.storeId, this.data)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(response => {
        this.qrImageSrc = URL.createObjectURL(response.blob);
      });
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
    if (this.qrImageSrc) {
      URL.revokeObjectURL(this.qrImageSrc);
    }
  }
}
